import React from 'react';
import { connect } from 'react-redux';
import { IDataStorage, Translate } from '../../core';
import { IControlProps, MapProps } from '.';
import { InputText, SelectButton } from '../prime';
import styles from './inputmultilang.module.scss';
import Common from '../../services/common';

export interface IMultiLang {
  dictionarykey: string;
  id: string | undefined;
  values?: {
    lang:string;
    text:string;
    updated?:boolean;
  }[]
}

interface IProps extends IControlProps<string | IMultiLang> {
  storage?: IDataStorage;
}

interface IState extends IControlProps<string | IMultiLang> {
  storage?: IDataStorage;
  /** Indica el mensaje de error si es que existe */
  validError?: string;

  lang?: string;
  values?: IMultiLang;
}

class Index extends React.Component<IProps, IState> {
  state : IState = { };
  key: string = `Input-${Common.object.uuidv4()}`;

  componentDidMount = () => {
    Index.getDerivedStateFromProps(this.props, this.state);
    if (this.props?.form && this.props?.name) this.props.form.add(this, this.props.name, () => { return undefined; /* pendiente de ver como validamos */});
    this.setState({ lang: this.state.storage?.languaje ?? 'es' })
  }
  static getDerivedStateFromProps = (p: IProps, s?: IState) : IState => {
    const getText = (lang:string, key:string) => {
      const real = Translate.get('API.Diccionario', lang)(key as string);
      if (real.startsWith('@') && real.includes('#')) return '';
      return real;
    }
    let res : IState = { };
    if (p?.storage !== s?.storage) res.storage = p.storage;
    if (p?.value !== s?.value && !!p.value) {
      if (typeof p.value === 'string') {
        const values : { lang:string; text:string; }[] = [];
        Translate.languages.forEach(lang => {
          values.push({
            lang: lang.code,
            text: getText(lang.code, p.value as string)
          });
        })

        res.values = {
          dictionarykey: p.value.split('.')[0],
          id: p.value.split('.')[1],
          values
        }
      } else if (typeof p.value === 'object') {
        res.values = p.value;
      }
    }
    return MapProps(res, p, s);
  }

  change = (text:string) => {
    const { values, required } = this.state;

    const obj = this.state.values?.values?.find(p => p.lang === this.state.lang);
    if (obj) {
      obj.text = text;
      obj.updated = true;
    }
    
    let error : string | undefined = undefined;
    if (required && values?.values?.find(p => !p.text || p.text === ''))
      error = 'campo requerido en todos los idiomas';

    this.setState({ value: values, values, validError: error }, () => this.props.onChange && this.props.onChange(values, error));
  }

  render() {
    const { validError } = this.state;
    const value = this.state.values?.values?.find(p => p.lang === this.state.lang);

    return (
      <div className={`form-group ${this.state.className ?? ''}`} style={this.state.style}>
        {this.state.title && <label className={(validError && styles.errortitle) ?? ''}>{this.state.title}</label>}
        <div className={`${styles.addons} p-inputgroup ${styles.container}`}>
          {this.state.required && 
            <span className={`p-inputgroup-addon ${(validError && styles.erroraddon) ?? ''}`}>
              <i className="pi pi-exclamation-circle" />
            </span>
          }          
          <InputText 
            id={this.key}
            value={value?.text}
            placeholder={this.state.placeholder}
            readOnly={this.state.disabled}
            tooltip={validError}
            tooltipOptions={{ position: 'bottom' }}
            className={`${styles.ctrl} ${validError && 'p-error'}`}
            onChange={e => !this.state.disabled && this.change((e.target as any).value)}
          />
          <SelectButton 
            optionLabel="code" optionValue="code" 
            multiple={false} 
            value={this.state.lang} options={Translate.languages} 
            onChange={e => !!e.value && this.setState({ lang: e.value }, () => {
              const value = this.state.values?.values?.find(p => p.lang === e.value);
              $(`#${this.key}`).val(value?.text ?? '').focus().select();
            })}
          />
        </div>
        {validError && <span className={styles.errordesc}>{validError}</span>}
      </div>
    );
  }
}

export default connect((s:any) => ({ storage:s.main }))(Index);
